module.exports = __webpack_public_path__ + "img/ry_18.b9a843dc.png";